import React, { Component } from 'react'
import style from './style'
import { Modal, Button } from 'controls'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import store from 'services/store'
import ContactForm from 'components/Forms/ContactForm'
import brokerClient from 'app/validators/brokerClient.js'
class ContactFooter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      success: false
    }
  }

  closeModal = () => {
    this.setState({ isModalOpen: false, success: false })
  }
  openModal = () => this.setState({ isModalOpen: true })

  static defaultProps = {
    title: 'Únete a nuestra Alianza. Estamos a tus órdenes.'
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.contactInfoRequestData.loading &&
      nextProps.contactInfoRequestData.finished &&
      !nextProps.contactInfoRequestData.error
    ) {
      this.setState({
        success: true
      })
    }
  }

  submit = values => {
    this.props.actions.sendContactInfo(values)
  }

  render() {
    const { title } = this.props
    const success = this.state.success

    let modalContent = null
    if (success) {
      modalContent = (
        <div className="success-message">
          <h1>Mensaje enviado</h1>
        </div>
      )
    } else {
      modalContent = (
        <ContactForm
          onSubmit={this.submit}
          validate={brokerClient}
          style={{
            padding: '0 20px',
            margin: '20px 0px 0px',
            maxWidth: '350px'
          }} 
          centered
        />
      )
    }

    return (
      <div className="contact-footer-container">
        <Modal
          isOpen={this.state.isModalOpen}
          onClose={this.closeModal}
          width="100%"
          maxWidth="350px"
        >
          {modalContent}
        </Modal>
        <h3>{title}</h3>
        <Button
          onClick={this.openModal}
          style={{ padding: '10px 64px 13px 65px', maxWidth: '160px' }}
          size="medium"
          color="primary"
        >
          Únete
        </Button>
        <style jsx global>
          {style}
        </style>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  contactInfoRequestData: store.footerContact('contact').selector(state)
})

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        sendContactInfo: store.footerContact('contact').action
      },
      dispatch
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactFooter)
